export enum UserStatusEnum {
	ACTIVE = 1,
	FROZEN = 2,
	DELETED = 3,
	SUPERADMIN = 4,
	PENDING = 5,
	PASSWORDRESET = 6,
}
